import React from 'react'
import SideBar from "../components/views/SideBar";

const PatientCredit = () => {
  return (
    <div className="wrapper">
    <SideBar />
    {/* <!-- Content Wrapper. Contains page content --> */}

    <div className="content-wrapper">
      {/* <!-- Content Header (Page header) --> */}
      <div className="content-header">
        <div className="container-fluid">
        PatientCredit
    </div>
    </div>
    </div>
    </div>
   
  )
}

export default PatientCredit